"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = function (ctx, rec, confidence) {
  return {
    confidence: confidence,
    name: rec.name(ctx),
    lang: rec.language ? rec.language() : undefined
  };
};